import { render, staticRenderFns } from "./ReleasesMenu.vue?vue&type=template&id=36d4c7c7&"
import script from "./ReleasesMenu.vue?vue&type=script&lang=js&"
export * from "./ReleasesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports